import React from 'react';
import { AddressElement } from '@stripe/react-stripe-js';

/**
 * Stripe Address Autocomplete Component
 * Extracted from LockerShippingModal for reusability
 * 
 * @param {Object} props
 * @param {Function} props.onChange - Callback when address changes (event) => void
 * @param {string} props.addressError - Error message to display
 * @param {Function} props.onShowManualForm - Callback when "Enter manually instead" is clicked
 * @param {boolean} props.loading - Whether the form is in loading state
 */
const StripeAddressAutocomplete = ({
  onChange,
  addressError = '',
  onShowManualForm,
  loading = false,
}) => {
  return (
    <div className="space-y-4">
      <div
        className="relative rounded-3xl border border-ponpon-navy/15 bg-white/90 p-4 shadow-sm"
        style={{minHeight: '280px'}}
      >
        <AddressElement
          options={{
            mode: 'shipping',
            fields: {phone: 'always'},
            validation: {phone: {required: 'always'}},
            autocomplete: {
              mode:
                process.env.REACT_APP_GOOGLE_PLACES_KEY &&
                process.env.REACT_APP_GOOGLE_PLACES_KEY.trim().length > 0
                  ? 'google_maps_api'
                  : 'automatic',
              apiKey:
                process.env.REACT_APP_GOOGLE_PLACES_KEY &&
                process.env.REACT_APP_GOOGLE_PLACES_KEY.trim().length > 0
                  ? process.env.REACT_APP_GOOGLE_PLACES_KEY.trim()
                  : undefined,
            },
          }}
          onChange={onChange}
        />
      </div>
      {addressError ? (
        <p className="rounded-2xl bg-ponpon-coral/10 px-4 py-2 text-xs text-ponpon-coral/80">
          {addressError}
        </p>
      ) : null}
      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={onShowManualForm}
          disabled={loading}
          className="text-sm font-semibold text-ponpon-navy/60 underline-offset-2 hover:underline disabled:opacity-50"
        >
          Enter manually instead
        </button>
      </div>
    </div>
  );
};

export default StripeAddressAutocomplete;

